export const environment = {
  production: true,
  graphql: 'https://www.communitystore.it/graphql',
  callback: 'https://www.communitystore.it/dashboard',
  serverUrl: 'https://www.communitystore.it/graphql',
  clientId: '100dfe8a-3079-4ff2-980c-a5737cc45db6',
  baseUrl: 'https://www.giglio.com',
  menu: false,
  instanaKey: 'm1-uceuFR5Gr7CcAy6pJ_w',
};
